import { permissionRegistry, type AppPermissionCapability } from './registry';
import type { PermissionContext, PermissionRule } from './types';

function matchesPermissionRule(rule: PermissionRule, context: PermissionContext): boolean {
  if (rule.allowSuperAdmin && context.isSuperAdmin) {
    return true;
  }

  if (rule.allOf && rule.allOf.length > 0 && !rule.allOf.every((permission) => context.can(permission))) {
    return false;
  }

  if (rule.anyOf && rule.anyOf.length > 0) {
    return rule.anyOf.some((permission) => context.can(permission));
  }

  return false;
}

export function hasPermissionCapability(
  capability: AppPermissionCapability,
  context: PermissionContext
): boolean {
  return matchesPermissionRule(permissionRegistry[capability], context);
}

export function getPermissionCapabilityMap<T extends AppPermissionCapability>(
  capabilities: readonly T[],
  context: PermissionContext
): Record<T, boolean> {
  return capabilities.reduce(
    (acc, capability) => {
      acc[capability] = hasPermissionCapability(capability, context);
      return acc;
    },
    {} as Record<T, boolean>
  );
}
